module.exports = __webpack_public_path__ + "img/case-logo-28.4c90774e.png";